<template>
  <div>
    <el-form>
      <el-row :gutter="24">
        <el-col :span="24">
          <div class="title">加签</div>
          <div v-if="hasTempNode" class="container">
            <span class="success">√ 已加签（{{ tempNode.flowNodeName || "未命名" }}）</span>
            <el-button type="text" icon="el-icon-close" @click="handleCancelTmpNode">取消加签</el-button>
          </div>
          <div v-else class="container">
            <span style="margin-right: 20px">未添加加签节点</span>
            <el-button type="text" icon="el-icon-plus" @click="handleAddNode">加签</el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <addTempNodeDlg ref="addTempNodeDlg" :flow-instance-id="flowInstanceNodeId" @ok="afterNodeAdd" />
  </div>
</template>

<script>
import addTempNodeDlg from "./addTempNodeDlg.vue";
import flowService from '@/CommonDP/service/flow-service';

export default {
  components: { addTempNodeDlg },
  props: {
    nodeDef: {
      type: Object,
      default: () => {}
    },

    flowInstanceNodeId: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      hasTempNode: false,
      tempNode: {}
    };
  },

  watch: {
    flowInstanceNodeId() {
      this.nextTick(() => this.queryAddedNode());
    }

  },

  mounted() {
    if (this.flowInstanceNodeId) {
      this.queryAddedNode();
    }
  },

  methods: {
    async queryAddedNode() {
      const res = await flowService.queryNextTempNode(this.flowInstanceNodeId);
      this.tempNode = res.data || {};
      this.hasTempNode = !!this.tempNode.flowNodeId;
    },

    handleAddNode() {
      this.$refs.addTempNodeDlg.showAdd();
    },

    afterNodeAdd() {
      this.queryAddedNode();
      this.$emit("added");
    },

    async handleCancelTmpNode() {
      // 取消加签
      if (!this.flowInstanceNodeId || !this.tempNode.flowNodeId) {
        this.$error("参数错误，没有节点或没有加签节点");
        return;
      }
      await this.$confirm("确认取消并删除加签的节点吗？");
      await flowService.deleteTmpNode(this.tempNode.flowNodeId);
      this.$success("取消成功");
      this.tempNode = {};
      this.hasTempNode = false;
      this.$emit("deleted");
    }

  }

};
</script>

<style lang="scss" scoped>
.title {
  font-size: 14px;
}

.success {
  padding: 5px;
  color: #08a134;
}

.container {
  margin-left: 20px;
}
</style>
